import { expand } from 'uri-template-lite';
import { apiClient } from '../../../../common/ApiClient';
import { createApiQueryHook } from '../../../../common/queryClient/createApiQueryHook';
import { UserBookmarkUrl } from './UserBookmarkUrl';
import { UserBookmarkQueryDtoType } from '../schema/types';

const getUserBookmarks = () =>
  apiClient
    .get<UserBookmarkQueryDtoType[]>(expand(UserBookmarkUrl.base, {}))
    .then((response) => response.data);

export const useListUserBookmarkQuery = createApiQueryHook(
  ['user-bookmarks'],
  getUserBookmarks,
);
